<template lang="pug">
.empty
  .empty-icon.fas.fa-times.fa-4x.text-error
  p.empty-title.h3 404
  p.empty-subtitle A página requisitada não foi encontrada
  .empty-action
    button.btn.btn-primary(@click="goBack") Voltar
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="stylus" scoped>
.empty
  height 100vh
  display flex
  flex-direction column
  justify-content center

  p
    margin-top 0
    margin-bottom 0
</style>
